import { useState } from "react";
import { motion } from "framer-motion";

const Question = ({ q, idx, onAnswer }) => {
  const [pick, setPick] = useState(null);
  const done = pick !== null;
  const choose = (i) => { if (done) return; setPick(i); onAnswer(i === q.answer); };
  return (
    <div className="quiz-q" data-testid={`quiz-question-${idx}`}>
      <p className="font-semibold text-[17px]"><span className="font-hand text-[#E4572E] text-xl mr-2">Q{idx + 1}.</span>{q.q}</p>
      <div className="grid sm:grid-cols-3 gap-3 mt-4">
        {q.options.map((o, i) => {
          const state = !done ? "" : i === q.answer ? "right" : i === pick ? "wrong" : "dim";
          return (
            <motion.button whileTap={{ scale: 0.97 }} key={o} onClick={() => choose(i)} className={`quiz-opt ${state}`} data-testid={`quiz-q${idx}-option-${i}`}>
              {o}
            </motion.button>
          );
        })}
      </div>
      {done && (
        <motion.p initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} className="font-hand text-lg mt-3 text-[#2B59C3]" data-testid={`quiz-q${idx}-explanation`}>
          {pick === q.answer ? "Sahi jawab! " : "Oops. "}{q.why}
        </motion.p>
      )}
    </div>
  );
};

export const Quiz = ({ items, moduleId }) => {
  const [score, setScore] = useState(0);
  const [answered, setAnswered] = useState(0);
  const [round, setRound] = useState(0);
  const onAnswer = (ok) => { setAnswered((a) => a + 1); if (ok) setScore((s) => s + 1); };
  const reset = () => { setScore(0); setAnswered(0); setRound((r) => r + 1); };
  return (
    <section className="quiz" data-testid={`quiz-module-${moduleId}`}>
      <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
        <h3 className="font-display text-5xl text-[#1F2A44]">Quick quiz</h3>
        <p className="font-hand text-xl" data-testid="quiz-score">Score: {score}/{items.length}</p>
      </div>
      <div className="grid gap-6" key={round}>
        {items.map((q, i) => <Question key={q.q} q={q} idx={i} onAnswer={onAnswer} />)}
      </div>
      {answered === items.length && (
        <button onClick={reset} className="pill-btn mt-8" data-testid="quiz-retry-button">Try again</button>
      )}
    </section>
  );
};
